import { ToolRole, Unit } from '@prisma/client'

export const unitFromString = (unit: string): Unit => {
  switch (unit?.toLowerCase()) {
    case 'inches':
      return Unit.INCHES
    case 'in':
      return Unit.INCHES
    case 'millimeters':
      return Unit.MILLIMETERS
    case 'mm':
      return Unit.MILLIMETERS
    default:
      return Unit.INCHES
  }
}

export const toolRoleFromString = (toolRole: string): ToolRole => {
  switch (toolRole?.toLowerCase()) {
    case 'roughing':
      return ToolRole.ROUGHING
    case 'finishing':
      return ToolRole.FINISHING
    case 'general purpose':
      return ToolRole.GENERAL_PURPOSE
    case 'spotting':
      return ToolRole.SPOTTING
    default:
      return ToolRole.GENERAL_PURPOSE
  }
}
